"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * The type key of an action must be a string (or serializable):
 * https://redux.js.org/faq/actions
 *
 * To enforce good practice, a TrackableAction must be a string. It would be
 * Possible to allow for other types, including non-serializable action type
 * values through the use of Generics (https://flow.org/en/docs/types/generics/)
 * and this may be added in a future version
 */

/**
 * The generic type S represents the Redux state in the application that makes
 * use of this project. The `trackCallback` function will be passed the state
 * of the Redux application present before and after the action occurs
 */

var AnalyticsMiddleware = function AnalyticsMiddleware(_ref) {
  var trackableActions = _ref.trackableActions,
      trackCallback = _ref.trackCallback;
  return function (_ref2) {
    var getState = _ref2.getState;
    return function (next) {
      return function (action) {
        // Skip the middleware if the action is not one of the trackable actions
        if (!trackableActions.includes(action.type)) return next(action); // Get the state pre and post the dispatching of the action and pass
        // this through to the trackCallback

        var preActionState = getState();
        var result = next(action);
        var postActionState = getState(); // Provide the callback with the exposed information

        trackCallback(action, preActionState, postActionState);
        return result;
      };
    };
  };
};

var _default = AnalyticsMiddleware;
exports["default"] = _default;